import React, { useState, useEffect, useRef } from 'react';

const WordCard = ({ word, onStudy, hideTranslationButton }) => {
  const [showTranslation, setShowTranslation] = useState(false);
  const [hasStudied, setHasStudied] = useState(false);
  const translateButtonRef = useRef(null);

  const toggleTranslation = () => {
    const newState = !showTranslation;
    setShowTranslation(newState);

    if (newState && !hasStudied && onStudy) {
      onStudy(word.id);
      setHasStudied(true);
    }
  };

  useEffect(() => {
    if (translateButtonRef.current) {
      translateButtonRef.current.focus();
    }
  }, []);

  return (
    <div className="word-card">
      <h3>{word.word}</h3>
      <p><strong>Thème :</strong> {word.topic}</p>

      {showTranslation && <p><strong>Traduction :</strong> {word.translation}</p>}

      {!hideTranslationButton && (
        <button ref={translateButtonRef} onClick={toggleTranslation}>
          {showTranslation ? 'Masquer la traduction' : 'Afficher la traduction'}
        </button>
      )}
    </div>
  );
};

export default WordCard;
